(self.webpackChunkyourkaya = self.webpackChunkyourkaya || []).push([
  [8363],
  {
    3244: () => {
      const e = document.getElementById("copy-text");
      document.getElementById("copy-link")?.addEventListener("click", () => {
        const t = document.createRange();
        t.selectNode(e), document.getSelection().addRange(t), navigator.clipboard.writeText(e.innerText);
      });
    },
  },
  (e) => {
    var t;
    (t = 3244), e((e.s = t));
  },
]);
